<template>
    <v-row justify="center">
        <v-dialog
            class="special-workday-modal"
            v-model="dialog"
            persistent
            max-width="600">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ headerText }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.specialWorkdayName')"
                            v-model="form.name"
                            placeholder=" "
                            autocomplete="off"
                            :rules="inputNameRules"
                            :error-messages="errors.name">
                        </v-text-field>

                        <v-combobox
                            @change="groupSelect"
                            v-model="selectedGroups"
                            item-text="name_with_workday"
                            :prepend-item="'Select All'"
                            :items="groups"
                            :rules="groupInputRules"
                            :error-messages="errors.for_group"
                            :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.forGroup')"
                            placeholder=" "
                            multiple>
                            <template v-slot:prepend-item>
                                <v-list-item
                                    @click="selectAll()"
                                    ripple>
                                    <v-list-item-action>
                                        <v-checkbox
                                            v-model="selectedAll"
                                            @click="selectAll()">
                                        </v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-combobox>

                        <v-menu
                            v-model="datePickerShow"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :class="{ 'date-special-workday': warning }"
                                    v-model="dateFormatted"
                                    :error-messages="errors.date"
                                    :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.workday')"
                                    placeholder=" "
                                    append-icon="event"
                                    @click:append="datePickerShow = true"
                                    :rules="inputRules"
                                    :hint="warning"
                                    persistent-hint
                                    readonly
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                :locale="localeLang"
                                v-model="form.date"
                                :rules="inputRules"
                                @input="datePickerShow = false"
                                :min="min">
                            </v-date-picker>
                        </v-menu>

                        <v-container>
                            <v-row>
                                <v-col
                                    class="pl-0"
                                    cols="3">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.checkinTime')"
                                        v-model="form.checkin_time"
                                        autocomplete="off"
                                        type="time"
                                        :rules="inputRules"
                                        step="1"
                                        :error-messages="errors.checkinTime"
                                        placeholder=" ">
                                    </v-text-field>
                                </v-col>
                                <v-col
                                    class="pl-0"
                                    cols="3">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.startTime')"
                                        v-model="form.start_time"
                                        autocomplete="off"
                                        type="time"
                                        :rules="inputRules"
                                        step="1"
                                        :error-messages="errors.startTime"
                                        placeholder=" ">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.breakTime')"
                                        v-model="form.breakhours"
                                        :rules="breakhoursRules"
                                        autocomplete="off"
                                        append-icon="mdi-timer"
                                        v-mask="'##:##'"
                                        :error-messages="errors.breakhours"
                                        @blur="checkTimeFormat()"
                                        @keyup="checkBreakTime($event)">
                                    </v-text-field>
                                </v-col>
                                <v-col
                                    class="pr-0"
                                    cols="3">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.endTime')"
                                        v-model="form.end_time"
                                        autocomplete="off"
                                        type="time"
                                        :rules="endTimeRules"
                                        step="1"
                                        :error-messages="errors.endTime"
                                        placeholder=" ">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-textarea
                            class="d-text-area"
                            :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.description')"
                            :maxlength="255"
                            v-model="form.description"
                            :rules="descriptionRules"
                            :error-messages="errors.description"
                            placeholder=" "
                            rows="2"
                            no-resize counter>
                        </v-textarea>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitSpecialWorkday()">
                        {{ $vuetify.lang.t('$vuetify.specialWorkdayFormModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'SpecialWorkdayFormModal',

    directives: {
        mask
    },

    props: {
        mode: {
            type: String,
            default: null
        },
        specialWorkdayId: {
            type: Number,
            default: null
        },
        min: {
            type: String,
            default: null
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        errorMsg () {
            return this.trans.specialWorkdayFormModal.msgError
        },
        inputRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.specialWorkdayFormModal.msgRequiredField)
            ]
        },
        breakhoursRules () {
            return [
                v => !this.isBreakhoursOver() || 'breakhours over workhous'
            ]
        },
        endTimeRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.specialWorkdayFormModal.msgRequiredField),
                v => v !== this.form.start_time || 'end time can not equal start time'
            ]
        },
        inputNameRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.specialWorkdayFormModal.msgRequiredField),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.specialWorkdayFormModal.msgLimitCharacters)
            ]
        },
        groupInputRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.specialWorkdayFormModal.msgRequiredField),
                v => this.$validator.arrayValueIn(v, this.groups, 'id', 'id', this.trans.specialWorkdayFormModal.msgRequiredField)
            ]
        },
        descriptionRules () {
            return [
                v => this.$validator.lengthNotExceed(v, 255, this.trans.specialWorkdayFormModal.msgLimitCharacters)
            ]
        },
        msgSaveSuccess () {
            let msg = this.trans.specialWorkdayFormModal.msgCreateSuccess
            if (this.mode === 'update') {
                msg = this.trans.specialWorkdayFormModal.msgUpdateSuccess
            }

            return {
                title: this.trans.specialWorkdayFormModal.congratulation,
                text: msg,
                type: 'success'
            }
        },
        msgErrorStartTimeAndEndTime () {
            return this.trans.specialWorkdayFormModal.msgErrorStartTimeAndEndTime
        },
        headerText () {
            if (this.mode === 'create') {
                return this.trans.specialWorkdayFormModal.addSpecialWorkday
            } else {
                return this.trans.specialWorkdayFormModal.editSpecialWorkday
            }
        }
    },
    data () {
        return {
            dialog: false,
            valid: true,
            datePickerShow: false,
            form: {
                name: null,
                date: '',
                checkin_time: '',
                start_time: '',
                end_time: '',
                breakhours: '01:00',
                description: '',
                groups: [],
                branchId: null
            },
            errors: [],
            dateFormatted: '',
            headModal: 'Warning Special Workday',
            titleModal: 'Do you want to create special workday on holiday ?',
            warning: null,
            groups: [],
            selectedGroups: [],
            selectedAll: false
        }
    },
    methods: {
        closeModal () {
            this.$refs.form.resetValidation()
            this.dialog = false
            this.errors = []
            this.datePickerShow = false
            this.selectedGroups = []
            this.selectedAll = false
            this.clearForm()
            this.$emit('modal-closed')
        },

        clearForm () {
            this.form = {
                name: null,
                date: '',
                checkin_time: '',
                start_time: '',
                end_time: '',
                breakhours: '01:00',
                description: '',
                groups: [],
                branchId: null
            }
            this.warning = null
        },

        async getSpecialWorkday (id) {
            const res = await this.axios.get(`specialworkday/${id}`)
            if (res && res.data && res.data.status === 'ok') {
                const responsData = res.data.special_workday
                this.form.name = responsData.name
                this.form.date = responsData.date
                this.form.description = responsData.description
                this.form.breakhours = responsData.breakhours
                this.form.checkin_time = this.$util.formatTime(responsData.checkin_time)
                this.form.start_time = this.$util.formatTime(responsData.start_time)
                this.form.end_time = this.$util.formatTime(responsData.end_time)
                this.selectedGroups = this.mapGroupDataFromGroupId(responsData.groups)
            }
        },

        mapGroupDataFromGroupId (groupIds) {
            const result = []
            for (let i = 0; i < groupIds.length; i++) {
                const foundGroup = this.groups.find(group => group.id === groupIds[i])
                result.push(foundGroup)
            }
            return result
        },

        async createSpecialWorkday () {
            this.$store.dispatch('setLoading', true)
            this.form.branchId = this.branchId
            this.form.groups = this.selectedGroups.map(group => group.id)
            const res = await this.axios.post('specialworkday/create', this.form)
            this.checkResponse(res, 'create')
        },

        async updateSpecialWorkday (specialWorkdayId) {
            this.$store.dispatch('setLoading', true)
            this.form.branchId = this.branchId
            this.form.groups = this.selectedGroups.map(group => group.id)
            const res = await this.axios.put(`specialworkday/edit/${this.specialWorkdayId}`, this.form)
            this.checkResponse(res, 'edit')
        },

        checkResponse (res, type) {
            if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success')
                this.dialog = false
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify(this.msgSaveSuccess)
            }
        },

        isBreakhoursOver () {
            const { start_time: startTime, end_time: endTime, breakhours } = this.form
            if (startTime === '' || endTime === '') {
                return false
            }
            const startDate = new Date()
            const endDate = new Date()

            if (this.form.start_time > this.form.end_time) {
                endDate.setDate(endDate.getDate() + 1)
            }

            const [startHour, startMinute, startSeconds = '00'] = startTime.split(':')
            startDate.setHours(startHour, startMinute, startSeconds)

            const [endHour, endMinute, endSeconds = '00'] = endTime.split(':')
            endDate.setHours(endHour, endMinute, endSeconds)

            const [breakHour, breakMinute] = breakhours.split(':')
            const breakhoursMilliSec = ((parseInt(breakHour) * 60) + (parseInt(breakMinute))) * 60 * 1000

            if (breakhoursMilliSec < endDate - startDate) {
                return false
            }

            return true
        },

        formatTimeWithSeconds () {
            const [checkinHour, checkinMinute, checkinSeconds = '00'] = this.form.checkin_time.split(':')
            this.form.checkin_time = `${checkinHour}:${checkinMinute}:${checkinSeconds}`

            const [startHour, startMinute, startSeconds = '00'] = this.form.start_time.split(':')
            this.form.start_time = `${startHour}:${startMinute}:${startSeconds}`

            const [endHour, endMinute, endSeconds = '00'] = this.form.end_time.split(':')
            this.form.end_time = `${endHour}:${endMinute}:${endSeconds}`
        },

        async submitSpecialWorkday () {
            if (!this.$refs.form.validate() || this.errors.date) {
                return
            }
            if (this.isBreakhoursOver()) {
                this.errors = { breakhours: 'break time is over workhours' }
                return
            }
            this.formatTimeWithSeconds()
            if (this.mode === 'create') {
                await this.createSpecialWorkday()
            } else if (this.mode === 'update') {
                await this.updateSpecialWorkday()
            }
        },

        setDefaultWorkday () {
            const todayDate = new Date()
            todayDate.setDate(todayDate.getDate() + 1)

            this.form.date = todayDate.toISOString().substr(0, 10)
        },

        async getGroups () {
            this.groups = await this.$util.getGroups(this.branchId)
        },

        groupSelect (v) {
            if (this.groupInputRules[0](v) === true) {
                if ((this.groupInputRules[1](v) === true) && (v.length === this.groups.length)) {
                    this.selectedAll = true
                    return
                }
            }

            this.selectedAll = false
        },

        selectAll () {
            this.selectedGroups = []
            if (this.selectedAll) {
                this.selectedAll = false
            } else {
                this.selectedAll = true
                this.selectedGroups = [...this.groups]
            }
        },

        checkBreakTime (e) {
            const value = e.target.value
            if (e.keyCode === 186) {
                this.form.breakhours = this.addColon(value)
            } else if (e.keyCode !== 8) {
                this.form.breakhours = this.checkTime(value)
            }
        },

        addColon (value) {
            if (value.length === 1) {
                return `0${value}:`
            }
            return value
        },

        checkTimeFormat () {
            if (this.form.breakhours.length === 1) {
                this.form.breakhours = `0${this.form.breakhours}:00`
            } else if (this.form.breakhours.length === 3) {
                this.form.breakhours = `${this.form.breakhours}00`
            } else if (this.form.breakhours.length === 4) {
                this.form.breakhours = `${this.form.breakhours}0`
            } else if (this.form.breakhours.length === 0) {
                this.form.breakhours = '01:00'
            }
        },

        checkTime (value) {
            if (value.length === 1 && value > 2) {
                return `0${value}:`
            }
            if (value.length === 2 && value > 23) {
                return '23:'
            } else if (value.length === 2 && value < 23) {
                return `${value}:`
            }
            if (value.length === 5) {
                let [hour, minute] = value.split(':')
                if (value.split(':')[1] > 59) {
                    minute = 59
                }
                if (value.split(':')[0] > 23) {
                    hour = 23
                }
                return `${hour}:${minute}`
            }
            return `${value}`
        }
    },

    created () {
        this.registerLang({
            specialWorkdayFormModal: [
                'msgError',
                'msgRequiredField',
                'msgLimitCharacters',
                'msgCreateSuccess',
                'msgUpdateSuccess',
                'congratulation',
                'msgErrorStartTimeAndEndTime',
                'addSpecialWorkday',
                'editSpecialWorkday'
            ]
        })
    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'create') {
                this.clearForm()
                this.setDefaultWorkday()
                await this.getGroups()
            } else if (newValue === 'update') {
                await this.getGroups()
                await this.getSpecialWorkday(this.specialWorkdayId)
            }
        },

        'form.date' () {
            this.dateFormatted = this.$util.formatDate(this.form.date)
        },

        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.date-special-workday {
    ::v-deep .v-messages__message {
        color: #f39c12;
        font-size: 14px;
    }
    ::v-deep .v-text-field__slot input {
        color: #f39c12;
    }
    ::v-deep .v-icon--link {
        color: #f39c12;
    }
    ::v-deep label {
        color: #f39c12;
    }
}
.special-workday-modal {
    .theme--light, .v-divider {
        border-color: rgb(148 148 148);
    }
}
</style>
